import clsx from 'clsx';
import { CSSProperties, HTMLAttributes, ReactNode } from 'react';

import { Button } from '../button/Button';
import styles from './Pane.module.scss';

export interface PaneProps extends HTMLAttributes<HTMLElement> {
  title: string;
  icon?: ReactNode;
  onClose?: () => void;
  children?: ReactNode;
  width?: CSSProperties['width'];
  backgroundColor?: CSSProperties['backgroundColor'];
  className?: string;
  headerClassName?: string;
  headerExtra?: ReactNode;
}

export const Pane = ({
  title,
  icon,
  onClose,
  children,
  width,
  backgroundColor,
  className,
  headerClassName,
  headerExtra,
  style,
  ...rest
}: PaneProps) => {
  const paneStyle: CSSProperties = {
    ...style,
    ...(width !== undefined && { width }),
    ...(backgroundColor !== undefined && { backgroundColor }),
  };

  return (
    <aside className={clsx(styles.root, className)} style={paneStyle} {...rest}>
      <div className={clsx(styles.header, headerClassName)}>
        <div className={styles.headerContent}>
          {icon && <div className={styles.icon}>{icon}</div>}
          <span className={styles.title}>{title}</span>
        </div>
        {onClose && (
          <Button
            className={styles.closeButton}
            iconName="Close"
            variant="empty"
            size="small"
            onClick={onClose}
            aria-label="Close pane"
          />
        )}
        {headerExtra}
      </div>
      <div className={styles.body}>{children}</div>
    </aside>
  );
};
